import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import I18n from '../../i18n'

function NavigationNative({ history }) {
  const [canGoBack, setCanGoBack] = useState(false)

  const updateBackStatus = () => {
    const navigationDepth = parseInt(sessionStorage.getItem('navigationDepth') || '0')
    const newCanGoBack = navigationDepth > 0 || (/^\/locations\/\d+/.test(window.location.pathname)) 
    setCanGoBack(newCanGoBack)
  }

  const handlePopState = () => {
    const currentDepth = parseInt(sessionStorage.getItem('navigationDepth') || '0')
    const newDepth = Math.max(0, currentDepth - 1)
    sessionStorage.setItem('navigationDepth', newDepth.toString())
    setTimeout(updateBackStatus, 50)
  }

  useEffect(() => {
    const handleBeforeVisit = () => {
      const currentDepth = parseInt(sessionStorage.getItem('navigationDepth') || '0')
      sessionStorage.setItem('navigationDepth', (currentDepth + 1).toString())
    }

    updateBackStatus()

    document.addEventListener('turbo:before-visit', handleBeforeVisit)
    document.addEventListener('turbo:load', updateBackStatus)
    window.addEventListener('popstate', handlePopState)

    return () => {
      document.removeEventListener('turbo:before-visit', handleBeforeVisit)
      document.removeEventListener('turbo:load', updateBackStatus)
      window.removeEventListener('popstate', handlePopState)
    }
  }, [])

  const handleBackClick = () => {
    if (history && history.back) {
      history.back()
    } else if (window.history) {
      window.history.back()
    }
    handlePopState()
  }

  if (!canGoBack) return null

  return (
    <NativeNavPlaceholder>
      <NativeNav
        data-controller="native-back-button"
        data-bridge-title={I18n.t('navigation.back')}
        onClick={handleBackClick}
      />
    </NativeNavPlaceholder>
  )
}

const NativeNavPlaceholder = styled.div`
  display: none;
`

const NativeNav = styled.div`
  display: none;
`

export default NavigationNative
